import { render, staticRenderFns } from "./FeedbackRoot.vue?vue&type=template&id=fb68f384"
import script from "./FeedbackRoot.vue?vue&type=script&lang=ts"
export * from "./FeedbackRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports